// removed by extract-text-webpack-plugin
module.exports = {"branch":"B5_XWHjm3Xez3AKdqZ1mL","detailThumbnail":"_15u2oupWWWqGlwSmuGsI5y","disable":"_3ez-a0S8rR9qu8YMNaWQX2","detailInfo":"_1WLa6Ol5qiWBD7IOQvEENZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Detail/BranchShopCard.scss
// module id = 454
// module chunks = 0